import { useEffect, useState } from "react";
import nexticon from "../images/icons/next-arrow.svg";
import "./CustomPagination.scss";
import backIcon from "../images/icons/previous.svg";
import nextIcon from "../images/icons/arrow-right-grey.svg";
import firstIcon from "../images/icons/firstpage.svg";
import lastIcon from "../images/icons/lastpage.svg";
import TimingFunctions from "../../assets/functions/TimingFunctions";

const Pagination = ({
  currentPage,
  rowsPerPage,
  totalCount,
  onPageClick,
  onPrev,
  onNext,
}) => {
  const [inputPage, setInputPage] = useState(currentPage);
  const { deBounce } = TimingFunctions();

  let limit = Math.ceil(totalCount / rowsPerPage);
  let page = +currentPage;

  const searchPagination = (targetPage) => {
    setInputPage(targetPage);
    deBounce(() => handleInputChange(targetPage), 1000);
  };

  const handleInputChange = async (targetPage) => {
    setInputPage(targetPage);
    if (targetPage >= 1 && targetPage <= limit) {
      onPageClick(targetPage);
    }
  };

  const getPageRange = (currentPage) => {
    const range = [];
    const start = Math.max(1, currentPage - 4);
    const end = Math.min(limit, currentPage + 4);
    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  };

  const pageRange = getPageRange(page);

  const onNextPage = () => {
    if (page < limit) {
      onNext && onNext(page + 1);
    }
  };

  const onPrevious = () => {
    if (page > 1) {
      onPrev && onPrev(page - 1);
    }
  };

  const onFirstPage = () => {
    onPageClick && onPageClick(1);
    setInputPage(1);
  };

  const onLastPage = () => {
    onPageClick && onPageClick(limit);
    setInputPage(limit);
  };

  const onPage = (number) => {
    onPageClick && onPageClick(number);
    setInputPage(number);
  };

  useEffect(() => {
    setInputPage(currentPage);
  }, [currentPage]);

  return (
    <div className="nk-block-between-md g-3 pagination-shell">
      <div className="g">
        <ul className="pagination custom-pagination-list justify-content-center justify-content-md-start">
          <li
            className={`page-item ${page === 1 ? "disabled" : ""}`}
            onClick={() => onFirstPage()}
          >
            <span className="page-link">
              <img className="page-icon" src={firstIcon} alt="first page" />
            </span>
          </li>
          <li
            className={`page-item ${page === 1 ? "disabled" : ""}`}
            onClick={() => onPrevious()}
          >
            <span className="page-link">
              <img className="page-icon" src={backIcon} alt="previous page" />
            </span>
          </li>
          {pageRange.map((pageNumber) => (
            <li
              key={pageNumber}
              className={`page-item ${page === pageNumber ? "active" : ""}`}
              onClick={() => onPage(pageNumber)}
            >
              <span className="page-link">{pageNumber}</span>
            </li>
          ))}
          <li
            className={`page-item ${page === limit ? "disabled" : ""}`}
            onClick={() => onNextPage()}
          >
            <span className="page-link">
              <img className="page-icon" src={nextIcon} alt="next page" />
            </span>
          </li>
          <li
            className={`page-item ${page === limit ? "disabled" : ""}`}
            onClick={() => onLastPage()}
          >
            <span className="page-link">
              <img className="page-icon" src={lastIcon} alt="last page" />
            </span>
          </li>
        </ul>
      </div>
      <div>
        <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
          <div className="pagination-jump-group">
            <div className="pagination-jump-row">
              <input
                type="number"
                min="1"
                max={limit}
                value={inputPage}
                className="page-input"
                placeholder="page"
                style={{ textAlign: "center" }}
                onChange={(e) => searchPagination(e?.target?.value)}
              />
              <span className="pagination-page-count">
                {limit} of page
              </span>
            </div>
            {inputPage > limit && (
              <span className="pagination-limit-error text-danger">
                Page number exceeds available pages
              </span>
            )}
          </div>
          <div
            className={`d-flex gap-3 px-2 py-3 justify-content-between align-items-center border rounded right-next ${
              page === limit ? "disabled" : ""
            }`}
            onClick={() => onNextPage()}
          >
            <p className="m-0">Next</p>
            <img className="next-cta-icon" src={nexticon} alt="next" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
